import React from 'react';

export const TestPage: React.FC = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-4xl font-bold text-red-600">
        🧪 PAGE DE TEST FONCTIONNE !
      </h1>
      <div className="p-8 bg-green-100 border-4 border-green-500 rounded-lg">
        <p className="text-3xl font-bold text-green-800">
          ✅ Si tu vois ceci, le routing fonctionne parfaitement
        </p>
      </div>
    </div>
  );
};
